import { LocalStorage } from 'classes/sc_localstorage'

export const shouldShowReferralAfterApplyModal = (applyCount) => {
  if (applyCount < 3) return false

  const dismissedAt = LocalStorage.fetchReferralAfterApplyDismissedAt()
  if (!dismissedAt) return true

  const dismissedDate = new Date(dismissedAt)
  const now = new Date()
  const daysDiff = (now - dismissedDate) / (1000 * 60 * 60 * 24)

  return daysDiff >= 30
}

export const dismissReferralAfterApplyModal = () => {
  LocalStorage.setReferralAfterApplyDismissedAt()
}
